<template>
	<div class="scrollContainer" v-if="(jeet11RetailsBanners || []).length > 0">
		<template v-for="(banner, index) in jeet11RetailsBanners">
			<v-flex
				:key="index"
				class="bannerCard"
				pa-2
				:style="
					jeet11RetailsBanners.length > 1
						? { width: 'calc(95% - 16px)' }
						: { width: '100%' }
				"
				@click="openBannerLink(banner)"
			>
				<img :src="banner.imageURL" class="bannerImage" />
			</v-flex>
		</template>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { FETCH_RETAIL_BANNERS } from "@/store/action-types";
export default {
	name: "Jeet11RetailBanners",
	mounted() {
		// this.fetchRetailBanners();
	},
	computed: {
		...mapState({
			jeet11RetailsBanners: state => state.jeet11.jeet11RetailBanners
		})
	},
	methods: {
		openBannerLink(banner) {
			if (banner.action.includes("https://")) {
				window.open(banner.action);
			} else {
				window.open(`https://www.jeet11.com${banner.action}`);
			}
		},
		fetchRetailBanners() {
			this.$store.dispatch(FETCH_RETAIL_BANNERS.dispatch);
		}
	}
};
</script>
<style scoped>
.scrollContainer {
	max-width: 100%;
	display: flex;
	overflow: auto;
	max-height: 200px;
}
.bannerImage {
	box-shadow: 0px 0px 8px rgba(7, 28, 80, 0.342);
	border-radius: 8px;
	cursor: pointer;
	max-height: 100%;
	min-width: 100%;
}
.bannerCard {
	display: flex;
	align-items: center;
	border-radius: 8px;
	flex-grow: 0;
	flex-shrink: 0;
	max-width: 600px;
}
</style>
